export default {"src":"/_next/static/media/auto-complete-back-left-icon.13e83a23.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};